/**
 * @generated SignedSource<<154a3866221efef58fdb0ab46d143b5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Notifications_viewer$data = {
  readonly conversations?: {
    readonly " $fragmentSpreads": FragmentRefs<"Conversations_conversations">;
  } | null;
  readonly regInfo?: ReadonlyArray<{
    readonly countryCode: string | null;
  } | null> | null;
  readonly " $fragmentType": "Notifications_viewer";
};
export type Notifications_viewer$key = {
  readonly " $data"?: Notifications_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"Notifications_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "buyerId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchNotifications"
    },
    {
      "defaultValue": 5,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "hasSessionCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Notifications_viewer",
  "selections": [
    {
      "condition": "hasSessionCountryCode",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": "regInfo",
          "args": null,
          "concreteType": "RegionalInfo",
          "kind": "LinkedField",
          "name": "regionalInfo",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "countryCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "fetchNotifications",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "conversations",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "buyerId"
            },
            {
              "kind": "Literal",
              "name": "filter",
              "value": "showUnreadOnly"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first"
            }
          ],
          "concreteType": "ConversationsSolrConnection",
          "kind": "LinkedField",
          "name": "conversationsSolr",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Conversations_conversations"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "4046c520c3aed78e4c84e5ed52c24f6f";

export default node;
